import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const especialidades = [
  { id: 1, nombre: "MATRONA" },
  { id: 2, nombre: "SALUD MENTAL" },
  { id: 3, nombre: "GERIATRÍA" },
  { id: 4, nombre: "ENFERMERÍA TRABAJO" },
  { id: 5, nombre: "FAMILIAR Y COMUNITARIA" },
  { id: 6, nombre: "PEDIATRÍA" },
  { id: 7, nombre: "MÉDICO QUIRÚRGICA" },
  { id: 8, nombre: "NINGUNA" },
];

const SelectEspecialidades = ({ name, value, onChange }) => (
  <FormControl fullWidth>
    <InputLabel id={`${name}-label`}>Especialidades</InputLabel>
    <Select
      labelId={`${name}-label`}
      name={name}
      multiple
      value={value}
      onChange={onChange}
      renderValue={(selected) =>
        selected
          .map((id) => especialidades.find((e) => e.id === id)?.nombre)
          .join(", ")
      }
    >
      {especialidades.map((e) => (
        <MenuItem key={e.id} value={e.id}>
          {e.nombre}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default SelectEspecialidades;
